import React, { useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import "./service1.css"
import { Link } from "react-router-dom";
import projectData from "../components/projectdata.js"

function Service1() {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true); // Control fade animation
  const hoodProjects = projectData.filter(project => project["service-type"].includes("hood"));
  const images = hoodProjects.map(project => project.images[0]);
  const projectNames = hoodProjects.map(project => project["project-name"]);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Start fade-out
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        setFade(true); // Fade-in new image
      }, 500); // 500ms fade-out before changing the image
    }, 5000); // Change image every 3s

    return () => clearInterval(interval);
  }, [images.length]);

    return (
      <div className="service1">

        <div className="service1-header">
          <h1>
            ติดตั้งระบบดูดอากาศ
            ภายในห้องครัว
          </h1>
          <ul>
            <li>ให้คำปรึกษาสำหรับการติดตั้งระบบดูดอากาศ ไม่ว่าจะเป็นระบบปกติหรือแฟรชแอร์</li>
            <li>ออกแบบและผลิตฮู้ดดูดควัน  ตามความต้องการของลูกค้า</li>
            <li>ติดตั้งระบบดูดอากาศภายในครัว</li>
          </ul>
        </div>

        { images.length !== 0 &&
        <div className="service-project-preview">
          <img src={images[currentIndex]} alt="" className={`fade ${fade ? "fade-in" : "fade-out"}`}/>
          <div className="banner-absolute-container">
              <p style={{fontStyle: 'italic', fontSize: '12px', fontWeight: '300'}} className="banner-italics">{currentIndex+1}/{images.length}</p>
              <p style={{paddingTop : '8px', fontSize: '14px'}} className="banner-project-name">{projectNames[currentIndex]}</p>
          </div>
        </div>
        }
        
        <div className="detail-section-1">
          <div>
          <h1>ครบจบ
          ในที่เดียว</h1>
          <p>ทางเราให้คำปรึกษา ออกแบบ พร้อมผลิตจริง <br /> ไปจนถึงการติดตั้ง พร้อมดูแลจนถึงปลายทาง</p>
          </div>
          
          <img src={require("../images/ระบบดูดอากาศ/image-section1.png")} alt="" />
        </div>

        <div className="detail-section-2">
          <div>
          <h1>ประสบการณ์ครบ <br />
          ทุกการติดตั้ง</h1>
          <p>
            กว่า 30 ปี ไม่ว่าจะเป็นครัวบ้าน หรือครัวอุตสาหกรรม <br />
            ติดตั้งโดยผู้เชี่ยวชาญและทีมงานมืออาชีพ <br />
            มั่นใจได้ทางคุณภาพและความปลอดภัย
          </p>
          </div>
          
          <img src={require("../images/ระบบดูดอากาศ/image-section2.png")} alt="" />
        </div>

        <div className="detail-section-3">
          <div>
          <h1>บริการทั่วถึง <br />
          ติดตั้งทั่วไทย</h1>
          <p>มีการบริการหลังการขายที่ดีเยี่ยม <br /> รับประกันจากร้านโดยตรง <br />
          รับติดตั้งทั่วประเทศไทย</p>
          </div>
          
          <img src={require("../images/ระบบดูดอากาศ/image-section3.png")} alt="" />
        </div>
        
        <Link to="/contact"><p className="contact-link-btn">ขอคำแนะนำจากผู้เชี่ยวชาญ <FaArrowRight className="right-icon" /></p></Link>
        
      </div>
    );
  }
  
  export default Service1;
